
import { Symbols } from 'Symbols';
import { initValidators, IModelAttributeValidationError, ErrorType } from '../Util';
import { Model } from 'Models/Model';
// % protected region % [Add extra imports and exports here] on begin
// Validation function for determining if the input is a phone number
export function isPhone(phone: string): boolean {
	if (phone) {
		// eslint-disable-next-line max-len
		return /^(\d{8}|\d{10}|\+{0,1}\d{2}\s*\d{3}\s*\d{3}\s*\d{3}|\+{0,1}\d{2}\s*\d{4}\s*\d{4}|\d{4}\s*\d{3}\s*\d{3}|\d{4}\s*\d{4})$/.test(phone);
	}
	return true;
}
// % protected region % [Add extra imports and exports here] end

export default function validate(
	validatorName: string,
	validatorFunction: (property: any, target: any) => Promise<string | null>,
) {
	return (target: Record<string | symbol, any>, key: string) => {
		initValidators(target, key);
		target[Symbols.validatorMap][key].push(validatorName);
		target[Symbols.validator].push(
			(model: Model): Promise<IModelAttributeValidationError | null> => new Promise(resolve => {
				validatorFunction(model[key], model).then(error => {
					if (error === null) {
						resolve(null);
						return;
					}

					resolve({
						errorType: ErrorType.INVALID,
						errorMessage: error,
						attributeName: key,
						target: model,
					});
				});
			}),
		);
	};
}
